import React from 'react'

const SpeakerProfile = ({ speaker }) => {
  const image = require('../../images/speakers/' + speaker.image)
  return (
    <div className="ts-speaker">
      <div className="speaker-img">
        <img className="img-fluid" src={image} alt="" />
      </div>
      <div className="ts-speaker-info">
        <p>
          {speaker.company} {speaker.title}
        </p>
        <h3 className="ts-title">{speaker.name}</h3>
        {speaker.twitter !== '' && (
          <a href={'https://twitter.com/' + speaker.twitter}>
            <i className="fa fa-twitter" />
            {speaker.twitter}
          </a>
        )}
        {speaker.facebook !== '' && (
          <a href={'https://www.facebook.com/' + speaker.facebook}>
            <i className="fa fa-facebook" />
            {speaker.facebook}
          </a>
        )}
        {speaker.github !== '' && (
          <a href={'https://github.com/' + speaker.github}>
            <i className="fa fa-github" />
            {speaker.github}
          </a>
        )}
        <p>{speaker.profile}</p>
      </div>
    </div>
  )
}

export default SpeakerProfile
